import { render, staticRenderFns } from "./AlertRoomBatteryList.vue?vue&type=template&id=a37290ca&lang=pug&"
import script from "./AlertRoomBatteryList.vue?vue&type=script&lang=ts&"
export * from "./AlertRoomBatteryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports